<div
  class="annotation-node flow-node"
  nz-resizable
  [style.width.px]="width()"
  [nzBounds]="'window'"
  [style.height.px]="height()"
  [style.--annotation-node-height.px]="height()"
  [nzMinWidth]="minWidth()"
  [nzMinHeight]="minHeight()"
  (nzResize)="onResize($event)">
  <nz-resize-handles (pointerdown)="$event.stopPropagation()" />
  @if (showIds()) {
    <span class="debug-id">{{ data.id }}</span>
  }

  <div class="node-actions">
    <span class="action">
      <i class="mynaui-pencil clickable" (pointerdown)="$event.stopPropagation()" (click)="editNode($event, data)"></i>
    </span>

    <span class="action">
      <i class="mynaui-trash clickable" (pointerdown)="$event.stopPropagation()" (click)="removeNode($event, data)"></i>
    </span>
  </div>
  <div
    class="node-wrap"
    [style.backgroundColor]="data.nodeData?.parameters?.[0]?.category || '#ffffa1'"
    [style.--sticky-bg-color]="data.nodeData?.parameters?.[0]?.category || '#ffffa1'">
    <div class="title" data-testid="title">
      <div class="icon" data-testid="icon" [attr.aria-label]="data.label">
        <i class="mynaui-message-dots"></i>
      </div>
      <div class="title-content" #marquee [class.marquee]="marquee.clientWidth < marquee.scrollWidth">
        <span class="title-type">{{ data.nodeData?.name }}</span>
      </div>
    </div>

    <div class="node-content" (pointerdown)="$event.stopPropagation()" (dblclick)="handleDoubleClick($event)">
      <div class="annotation" [innerHTML]="data.nodeData?.parameters?.[0]?.value?.trim()"></div>
    </div>
  </div>
</div>
